<div class="card mb-5 scatter-chart-card">
  <div class="card-header" style="border-bottom: none;">
    <div class="card-title d-flex flex-column">
      <h4>{{ data?.title }}</h4>
    </div>
  </div>
  <div class="card-body scatter-chart-body">
    <div class="scatter-symbol-legend" *ngIf="legendSymbolRows.length">
      <table>
        <tbody>
          <tr>
            <td *ngFor="let row of legendSymbolRows">
              <span
                class="scatter-legend-symbol"
                [ngClass]="'scatter-legend-symbol--' + row.symbolClass"
                [style.--legend-color]="row.color"
                [attr.aria-label]="row.symbolClass"
              ></span>
            </td>
          </tr>
          <tr>
            <td *ngFor="let row of legendSymbolRows">{{ row.key }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      class="configurable-multi-series-scatter-chart"
      id="{{ data?.widgetId }}"
      [style.block-size]="data?.chartConfig?.blockSize || data?.blockSize || null"
    ></div>
  </div>
</div>
